import { render } from "./LayBenchMark.vue?vue&type=template&id=63861fb2&scoped=true"
import script from "./LayBenchMark.vue?vue&type=script&lang=js"
export * from "./LayBenchMark.vue?vue&type=script&lang=js"

import "./LayBenchMark.vue?vue&type=style&index=0&id=63861fb2&lang=less&scoped=true"

import exportComponent from "/aqua/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63861fb2"]])

export default __exports__